module.exports = __webpack_public_path__ + "img/collection-diamondJewelryRedgold.4b4c2c7.webp";